__turbopack_context__.v({
  "className": "dm_sans_3013e0f7-module__dEw5ra__className",
});
